export enum eAlertType {
  Success = 0,
  Error = 1,
}

export interface ICmpAlert {
  alertMessage: string;
  alertType: eAlertType;
}
